<template>
  <section class="content mt-5">
    <mdb-container>
      <mdb-row>
        <mdb-col col="12" md="8" offset-md="2">
          <div class="form-logo text-center mb-5">
            <router-link :to="{ name: 'top' }">
              <img src="@/assets/images/waaarp_logo_bk.png" />
            </router-link>
          </div>
          <mdb-card>
            <mdb-card-body class="mx-4">
              <validation-observer v-slot="{ handleSubmit }">
                <form novalidate @submit.prevent="() => { validated = true; handleSubmit(submit) }" class="secondary-form">
                  <validation-provider name="氏名" rules="required" v-slot="{ errors }">
                    <custom-mdb-input
                      class="my-5"
                      label="氏名"
                      name="name"
                      type="text"
                      icon="user"
                      v-model="name"
                      :customValidation="validated && errors.length != 0"
                      :isValid="errors.length == 0"
                      :invalidFeedback="errors[0]"
                    />
                  </validation-provider>
                  <validation-provider name="メールアドレス" rules="required|email" v-slot="{ errors }">
                    <custom-mdb-input
                      class="my-5"
                      label="メールアドレス"
                      name="email"
                      type="email"
                      icon="envelope"
                      v-model="email"
                      :customValidation="validated && errors.length != 0"
                      :isValid="errors.length == 0"
                      :invalidFeedback="errors[0]"
                    />
                  </validation-provider>
                  <validation-provider name="パスワード" rules="required|min:6" v-slot="{ errors }" vid="password">
                    <custom-mdb-input
                      class="my-5"
                      label="パスワード"
                      name="password"
                      type="password"
                      icon="lock"
                      v-model="password"
                      :customValidation="validated && errors.length != 0"
                      :isValid="errors.length == 0"
                      :invalidFeedback="errors[0]"
                    />
                  </validation-provider>
                  <validation-provider name="パスワード（確認用）" rules="required|confirmed:password" v-slot="{ errors }">
                    <custom-mdb-input
                      class="my-5"
                      label="パスワード（確認用）"
                      name="passwordConfirmation"
                      type="password"
                      icon="check-square"
                      v-model="passwordConfirmation"
                      :customValidation="validated && errors.length != 0"
                      :isValid="errors.length == 0"
                      :invalidFeedback="errors[0]"
                    />
                  </validation-provider>
                  <div class="text-center">
                    <div class="d-inline-block clickable" @click="toggleRegulationModal">
                      <custom-mdb-input class="disabled" type="checkbox" id="agreed" :label="checkBoxLabel" v-model="agreed"/>
                    </div>
                  </div>
                  <div class="text-center my-3">
                    <mdb-btn rounded color="primary" type="submit" :class="{ 'disabled': httpRequesting || !agreed }">
                      <span v-if="httpRequesting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      登録
                    </mdb-btn>
                  </div>
                  <div class="modal-footer font-small pt-3">
                    <router-link :to="{ name: 'signIn' }" class="font-weight-bold">
                      <mdb-icon icon="sign-in-alt" class="mr-2"/>既にアカウントをお持ちの方
                    </router-link>
                  </div>
                </form>
              </validation-observer>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <RegulationModal
      :modal="regulationModal"
      :agreed="agreed"
      @close="regulationModal = false"
      @agreed="regulationModal = false; enabledCheckBox = true;"
    />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import RegulationModal from '@/components/molecules/RegulationModal'

export default {
  name: 'SignUp',
  components: {
    RegulationModal
  },
  data () {
    return {
      name: '',
      email: '',
      password: '',
      passwordConfirmation: '',
      regulationModal: false,
      agreed: false,
      validated: false,
      enabledCheckBox: false
    }
  },
  computed: {
    checkBoxLabel: function() {
      if (this.enabledCheckBox) {
        return '個人情報の取扱規定、利用規約に同意する'
      } else {
        return '個人情報の取扱規定、利用規約を確認する'
      }
    },
    ...mapGetters({
      httpSuccess: 'httpSuccess',
      httpRequesting: 'httpRequesting'
    })
  },
  methods: {
    async submit() {
      await this.signUp({
        user: {
          name: this.name,
          email: this.email,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation
        }
      })
      if (this.httpSuccess) {
        this.$router.push({ name: 'top' })
      }
    },
    toggleRegulationModal: function() {
      if (this.agreed) {
        this.agreed = false
        this.enabledCheckBox = false
      } else if (this.enabledCheckBox) {
        this.agreed = true
      } else {
        this.regulationModal = true
      }
    },
    ...mapActions({
      signUp: 'auth/signUp'
    })
  }
}
</script>
